/**
 * Ограничение даты документа периодом из фильтра вкладки («Период с» / «по»).
 * Сравнение — по календарным дням по часам браузера, как даты показываются в календарях.
 */

type DateValue = Date | number | string | null | undefined;

/** Календарный день (ГГГГММДД); null для пустой или невалидной даты */
export function dayKey(value: DateValue): number | null {
    if (value === null || value === undefined || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return null;
    return date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
}

/** День вне периода [from; to] (границы включительно; пустая граница не ограничивает) */
export function isOutOfPeriod(value: DateValue, from: DateValue, to: DateValue): boolean {
    const day = dayKey(value);
    if (day === null) return false;
    const fromDay = dayKey(from);
    const toDay = dayKey(to);
    return (fromDay !== null && day < fromDay) || (toDay !== null && day > toDay);
}

/** Дата в пределах периода: если она вне периода — ближайшая граница (начало дня), иначе без изменений */
export function clampToPeriod(value: Date, from: DateValue, to: DateValue): Date {
    const day = dayKey(value);
    if (day === null) return value;
    const fromDay = dayKey(from);
    const toDay = dayKey(to);
    let bound: number | null = null;
    if (fromDay !== null && day < fromDay) {
        bound = fromDay;
    } else if (toDay !== null && day > toDay) {
        bound = toDay;
    }
    if (bound === null) return value;
    return new Date(Math.floor(bound / 10000), Math.floor(bound / 100) % 100 - 1, bound % 100);
}
